import { styled } from 'stitches.config'

export const HealthToGoRoot = styled('div', {
  background: '$primary-700',
})

export const HealthToGoFlex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxWidth: '500px',
  margin: 'auto',

  '@bp3': {
    flexDirection: 'row',
    maxWidth: '2100px',
  },
})

export const CopyContainer = styled('div', {
  padding: '42px 16px',

  '@bp3': {
    padding: '32px',
  },

  '@bp4': {
    padding: '64px',
  },
})

export const CopyColumn = styled('div', {
  color: '$accent-white',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',

  '@bp3': {
    width: '50%',
  },
})

export const ImageColumn = styled('div', {
  aspectRatio: 'none',
  width: '100%',
  lineHeight: 0,

  '@bp3': {
    aspectRatio: 730 / 462,
    maxWidth: 'none',
    width: '50%',
  },
})

export const List = styled('ul', {
  marginLeft: '8px',
  marginTop: '16px',
  '& li': {
    fontSize: '$body',
    letterSpacing: '$body',
    lineHeight: '$body',
    listStyleType: 'disc !important',
    marginBottom: '4px',
  },

  '@bp3': {
    marginLeft: '24px',
  },
})

export const Header = styled('h2', {
  fontFamily: '$display',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  textAlign: 'center',

  '@bp3': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
})
